import { render, staticRenderFns } from "./revisitList.vue?vue&type=template&id=4c02e63f&scoped=true&"
import script from "./revisitList.vue?vue&type=script&lang=ts&"
export * from "./revisitList.vue?vue&type=script&lang=ts&"
import style0 from "./revisitList.vue?vue&type=style&index=0&id=4c02e63f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02e63f",
  null
  
)

export default component.exports